import { render, staticRenderFns } from "./friendship-link.vue?vue&type=template&id=6b742e1e"
import script from "./friendship-link.vue?vue&type=script&lang=js"
export * from "./friendship-link.vue?vue&type=script&lang=js"
import style0 from "./friendship-link.vue?vue&type=style&index=0&id=6b742e1e&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports